import useIsClientSide from './useIsClientSide'

const useUiSpecs = () => {
  const isClientSide = useIsClientSide()

  return isClientSide ? {
    headerHeight: document.querySelector('#js-header')?.clientHeight || 0,
    pageNavHeight: document.querySelector('#js-country-city-page-nav')?.clientHeight || 0
  } : {
    headerHeight: 0,
    pageNavHeight: 0
  }
}

export default useUiSpecs
